






























import { Component, Vue } from "vue-property-decorator";

@Component
export default class AuthPage extends Vue {
  created() {
    this.$store.commit("fullPage", true);
    this.$store.commit("asideRightToggle", false);
  }

  beforeDestroy() {
    this.$store.commit("fullPage", false);
  }
}
